import React from 'react';
import { withRouter } from 'next/router';

import LocationList from '../components/companyCard/locationList';
import AboutZippia from '../layouts/homePage/AboutZippia';
import MostCommonJobs from '../layouts/homePage/MostCommonJobs';
import ResumeCalloutSection from '../layouts/homePage/ResumeCalloutSection';
import Testimonial from '../layouts/homePage/Testimonial';
import WhatIsZippia from '../layouts/homePage/WhatIsZippia';
import ZippiaCompanyBadge from '../layouts/homePage/ZippiaCompanyBadge';
import HomeSurveyEntry from '../layouts/HomeSurveyEntry';
import AdviceExplorer from '../layouts/section/AdviceExplorer';
import BestCompaniesToWork from '../layouts/section/BestCompaniesToWork';
import JobsByIndustry from '../layouts/section/JobsByIndustry';
import JobsByStates from '../layouts/section/JobsByStates';
import Meta from '../widgets/Meta';

class Home extends React.Component {
  static async getInitialProps({ req, res }) {
    if (req) {
      return {
        data: res ? res.data : null,
        user: req ? req.user : null,
        locals: res ? res.locals : null,
      };
    } else {
      // Return page detail from __NEXT_DATA__
      return window.__NEXT_DATA__.props.pageProps;
    }
  }

  render() {
    const { data, user } = this.props;

    return (
      <div className="main_inner">
        <Meta {...data.metadata} />
        <HomeSurveyEntry user={user} homePage />
        <WhatIsZippia />
        <Testimonial usersList={data.testimonials} />
        <ZippiaCompanyBadge />
        <BestCompaniesToWork
          isHomePage={data.isHomePage}
          isExplorePage={false}
          topCompaniesData={data.topCompanies}
        />
        <div>
          <LocationList locationList={data.statesList} />
          <LocationList locationList={data.cities} isCity={true} />
        </div>
        <AboutZippia siteMentions={data.siteMentions} />
        <MostCommonJobs mostCommonJobTitles={data.mostCommonJobTitles} />
        <JobsByStates
          containerClassName={'z-mt-80'}
          isHomePage={data.isHomePage}
          states={data.states}
          nofollow={data.nofollow}
        />
        <JobsByIndustry
          isExplorePage={false}
          isHomePage={data.isHomePage}
          headerTitle="Search careers by industry"
        />
        <AdviceExplorer
          desktopDevice={data.desktopDevice}
          newsArticles={data.zippiaAdvicesHome}
          isHomePage={data.isHomePage}
          title
          headerText="ZIPPIA ADVICE & RANKINGS"
          explore={false}
          className="section rankings-sec pt-0 container mt-48"
          id="advices"
        />

        <ResumeCalloutSection />
        <AdviceExplorer
          desktopDevice={data.desktopDevice}
          newsArticles={data.newArticles}
          isHomePage={data.isHomePage}
          title
          headerText={`Job Search Resources`}
          explore={false}
          className="section rankings-sec container mb-5"
          id="advices"
        />
      </div>
    );
  }
}

export default withRouter(Home);
